const appendSideMenuHeader = () => {
  const mainMenu = document.querySelector(".md-toolbar-row");
  const sidemenuHeader = document.createElement("div");
  sidemenuHeader.className = "md-drawer-header";
  const span = document.createElement("span");
  span.className = "back-btn i-arr-l-lt";
  span.textContent = "Products";
  sidemenuHeader.appendChild(span);

  mainMenu.insertBefore(sidemenuHeader, mainMenu.children[0]);
};

const setSideMenuID = () => {
  const sideMenuButton = document.querySelector(".main-header .md-toolbar-section-end button:last-child");
  sideMenuButton.id = "nav-sitemap";
  sideMenuButton.setAttribute("data-target-id", "side-menu");
}

const SideMenuHandler = {
    // Constants
    menuSelectors: {
        sideMenu: '.md-drawer', //side menu container
        contentMenu: '.menu-content', //child of #side-menu
        footerMenu: '.menu-footer', //child of #side-menu
        mainNav: '.main-header',
        sideMenuHeader: '.md-drawer-header', //child of .main-header
        hamburgerBtn: '#nav-sitemap', //child of .main-header
        footerTxtLogin: '.txt-login',
        footerTxtAccount: '.txt-account'
    },

    homeMenu: "home-menu",
    currentMenu: "home-menu",
    menu: null,
    contentMenu: null,
    footerMenu: null,
    mainNav: null,
    sideMenuHeader: null,
    hamburgerBtn: null,
    arrSiblingMenu: ["nav-account-menu"],

    elemReady: true,

    initElements: function() {
        try {
            this.menu = document.querySelector(this.menuSelectors.sideMenu);
            this.contentMenu = this.menu.querySelector(this.menuSelectors.contentMenu);
            this.footerMenu = this.menu.querySelector(this.menuSelectors.footerMenu);

            this.mainNav = document.querySelector(this.menuSelectors.mainNav);
            this.sideMenuHeader = this.mainNav.querySelector(this.menuSelectors.sideMenuHeader);
            this.hamburgerBtn = this.mainNav.querySelector(this.menuSelectors.hamburgerBtn);

            const missingElements = [];

            if (!this.menu) missingElements.push('sideMenu');
            if (!this.mainNav) missingElements.push('mainNav');
            if (!this.sideMenuHeader) missingElements.push('sideMenuHeader');
            if (!this.hamburgerBtn) missingElements.push('hamburgerBtn');
            if (missingElements.length > 0) {
                throw new Error(`Required menu elements not found: ${missingElements.join(', ')}`);
            }

        } catch (error) {
            console.error('Failed to initialize menu elements:', error);
            this.elemReady = false;
        }
    },

    //Move selected submenu to under their parent position
    initSubmenu: function() {      
        const expandMenus = document.querySelectorAll(`.md-drawer .sub-menu[open='expand']`);        
        expandMenus.forEach(submenu => {          
            const menuId = submenu.dataset.id;
            const menuItem = document.querySelector(`.md-drawer .menu-item[data-target="${menuId}"]`);
            if (menuItem && !menuItem.contains(submenu)) {
                menuItem.after(submenu);
            }
        });
    },

    setFooterLoginText: function(){
        // if(global.store.hasStore != '0'){
        //     const booHaveEmail = global.store.customer.email != "";
        //     this.footerMenu.querySelector(this.menuSelectors.footerTxtLogin).classList.toggle("active", !booHaveEmail);
        //     this.footerMenu.querySelector(this.menuSelectors.footerTxtAccount).classList.toggle("active", booHaveEmail);
        // }
    },

    getCountryName: function() {
        const currentCountryID = global.store.storeCountryID;
        if (!currentCountryID) return global.store.storeName;
    
        const countryItem = [...this.menu.querySelectorAll('[data-countryid]')].find(item => 
            Number(item.dataset.countryid.split(',')[0]) === currentCountryID
        );
    
        return countryItem ? countryItem.getAttribute("value") : global.store.storeName;
    },

    setFooterCountryName: function(){
        const btnLocation = this.footerMenu.querySelector(".btn-location");
        if(!btnLocation || btnLocation.querySelector("div")){
            return;
        }

        const newDiv = document.createElement("div");
        newDiv.className = "i-globe txt-storename";
        newDiv.innerHTML = this.getCountryName();
        btnLocation.appendChild(newDiv);
    },

    hasMenuDataID: function(menuId) {
        return this.getMenuDataID(menuId) != null;
    },

    getMenuDataID: function(menuId) {
        return this.menu.querySelector(`[data-id="${menuId}"]`);
    },

    openMethod: function(menuId) {
        return (this.hasMenuDataID(menuId)) ? this.getMenuDataID(menuId).getAttribute("open") : "";
    },

    setCurrentMenu: function(menuId) {
        document.querySelector(".md-drawer .menu-content").dataset.current = menuId;
    },

    resetSideMenu: function(){
        this.mainNav.classList.remove("open-side-menu-header");
        this.setCurrentMenu("");
        this.menu.querySelectorAll(".sub-menu.active, .sub-menu.open").forEach(submenu => {
            if(submenu.classList.contains("open")){
                submenu.style.display = "none";
            }
            submenu.classList.remove("active","open");
        });
        this.menu.querySelectorAll(".menu-item.i-minus").forEach(menuItem => {
            menuItem.classList.remove("i-minus");
            menuItem.classList.add("i-plus");
        });
        this.menu.querySelectorAll("[data-countryid].selected").forEach(countryItem => {
            countryItem.classList.remove("selected");
        });
    },

    toggleSideMenuHeader: function(targetMenu) {
        //menu header
        const isHomeMenu = targetMenu === this.homeMenu;
        this.sideMenuHeader.querySelector(".back-btn").innerHTML = isHomeMenu ? "" : this.getMenuDataID(targetMenu).getAttribute("data-header");
        this.mainNav.classList.toggle("open-side-menu-header", !isHomeMenu);
    },

    toggleMenu: function(targetMenu) {
        if (this.openMethod(targetMenu) === "expand") {
            this.getMenuDataID(targetMenu).classList.toggle("open");
            const submenu = document.querySelector(`${this.menuSelectors.sideMenu} li.sub-menu[data-id="${targetMenu}"]`);
            //submenu.style.display = ((submenu.style.display === "list-item"))? "none": "list-item";              
            // if(this.getMenuDataID(targetMenu).classList.contains("open")){              
            //   submenu.style.display = "none";              
            // }else{
            //   submenu.style.display = "list-item";
            // }
            return;
        }

        //if target menu is sibling menu (not side menu child), skip statement
        if(this.arrSiblingMenu.includes(targetMenu)){
            switch(targetMenu){
                case "nav-account-menu":
                    document.querySelector(`[data-target-id="nav-account-menu"]`).click();
                    break;
            }
            return;
        }

        //if not expand menu, update content data
        this.setCurrentMenu(targetMenu);

        // show header and back button
        this.toggleSideMenuHeader(targetMenu);

        // The "Home" menu always stays on the last layer of the side menu,
        // so no need to toggle its active state.
        // The target menu is always visible before sliding in from the right and exiting.
        // Before showing the target menu, remove "active" from all existing submenus.
        if(targetMenu != "home-menu"){
            // Remove "active" from all sub-menus
            this.menu.querySelectorAll(".sub-menu.active").forEach(submenu => submenu.classList.remove("active"));
            // Update the current menu reference
            this.currentMenu = targetMenu;
            // Add "active" to the target menu
            this.getMenuDataID(this.currentMenu).classList.add("active");
        }
    },

    toggleExpandIcon: function(element) {
        if (!element.classList.contains("i-plus") && !element.classList.contains("i-minus")) {
            return;
        }
        
        const isPlus = element.classList.contains("i-plus");
        element.classList.toggle("i-plus", !isPlus);
        element.classList.toggle("i-minus", isPlus);
    },

    observeExpandState: function(target) {
        let timeoutTouch=null, observer=null;
        if (!target.hasTouchObserver) {
            target.hasTouchObserver = true;

            const disconnectObserver = function(){
                target.classList.remove("touch");
                if(observer) observer.disconnect();
                if(timeoutTouch) clearTimeout(timeoutTouch);
                target.hasTouchObserver = false;
            };

            observer = new MutationObserver((mutations) => {
                if (mutations.some(mutation => mutation.attributeName === "class" && target.classList.contains("i-minus"))) {
                    disconnectObserver();
                }
            });
            observer.observe(target, { attributes: true });

            timeoutTouch = setTimeout(() => {
                disconnectObserver();
            }, 100);
        }
    },

    addEventListeners: function() {
        this.hamburgerBtn.addEventListener("click", (e) => {
            e.preventDefault();

            if(document.querySelector("body.open-side-menu")==null){
                //when open side menu
                document.body.classList.add("open-side-menu");

                this.resetSideMenu();

                //update info
                //this.setFooterLoginText();
                //this.setFooterCountryName();

                //show home menu
                this.toggleMenu(this.homeMenu);
            }else{
              document.body.classList.remove("open-side-menu");
            }
        });

        this.sideMenuHeader.addEventListener("click", (e) => {
            e.stopPropagation();
            //get current menu from side menu data current, remove menu class active
            this.menu.querySelector(`.sub-menu[data-id="${this.contentMenu.dataset.current}"]`).classList.remove("active");
            this.toggleMenu(this.homeMenu);
        });

        // Menu click handlers
        this.menu.addEventListener("click", (e) => {
            const item = e.target;
            const parentElement = item.parentElement;

            //if have url
            if (item.dataset.href) {
                const hrefTarget = item.dataset.hrefTarget || "_self";
                
                if (hrefTarget === "_self") {
                    try {
                        location.href = new URL(item.dataset.href, location.origin).href;
                    } catch (e) {
                        console.log("Error: incorrect url");
                        return; //block xss
                    }
                } else {
                    try {
                        //return when incorrect url
                        const url = new URL(item.dataset.href.trim());
                        if (url.protocol !== "http:" && url.protocol !== "https:") return;
                
                        window.open(url.href, "_blank", "noopener,noreferrer");
                    } catch (e) {
                        console.log("Error: incorrect url");
                        return; //block xss
                    }
                }

                return;
            }
            
            //if is country selector
            if(item.dataset.countryid && parentElement && parentElement.parentElement.matches(`${this.menuSelectors.sideMenu} li[data-id='location-menu']`)) {
                item.classList.add("selected");
                location.href = GetAbsoluteURL() + "/home/country?id=" + item.dataset.countryid;
                return;
            }

            const isFooterButton = ["btn-login", "btn-location"].some(className => parentElement.classList.contains(className));

            //if dun have menu target and not footer button
            if (!item.hasAttribute("data-target") && !isFooterButton) return;

            e.stopPropagation();

            const targetMenu = isFooterButton ? parentElement.dataset.target : item.dataset.target;

            this.toggleMenu(targetMenu);
            this.toggleExpandIcon(item);
        });

        // menu item touch handler
        // when touch start - add classname 'touch' on elem
        // when touch end or cancel - remove classname 'touch' on elem
        ['touchstart', 'touchcancel'].forEach(event => {
            this.menu.addEventListener(event, e => {
                if (e.target.classList.contains('menu-item')) {
                    e.target.classList.toggle('touch', event === 'touchstart');
                }
            });
        });

        this.menu.addEventListener("touchend", (e) => {
            const target = e.target;
            
            // if not menu item, return
            if (!target.classList.contains("menu-item")) return;

            const targetSibling = target.nextElementSibling;

            if (!target.getAttribute("data-target") ||
                target.classList.contains("i-minus") ||
                !targetSibling ||
                targetSibling.getAttribute("open") !== "expand") {
                    return target.classList.remove("touch");
            }

            //if expand item not open, observe expand state
            this.observeExpandState(target);
        });

        document.querySelector(".md-drawer .cross-btn").addEventListener("click", (e) => {
            document.body.classList.remove("open-side-menu");
        });
    },

    init: function() {        
        appendSideMenuHeader();
        setSideMenuID();

        this.initElements();
        if(this.elemReady){
          const app = document.querySelector('#app');

          const obs = new MutationObserver((_, o) => {
            if (app.querySelector(`.md-drawer .sub-menu[open='expand']`)) {
              o.disconnect();
              this.initSubmenu();
              this.addEventListeners();
            }
          });

          obs.observe(app, { childList: true, subtree: true });
        }
    }

};

export default SideMenuHandler